import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class LoadingService {
	private refCounter: number;
	private show = false;
	private showNotifier: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public isLoading(): Observable<boolean> {
		return this.showNotifier.asObservable();
	}

	public request(): void {
		if (this.show) {
			this.refCounter++;
		} else {
			this.refCounter = 1;
			this.show = true;
			this.showNotifier.next(this.show);
		}
	}

	public release(): void {
		if (this.show) {
			this.refCounter--;
			if (this.refCounter === 0) {
				this.show = false;
				this.showNotifier.next(this.show);
			}
		}
	}
}
